import { useEffect, useMemo } from "react";
import { useAlertsStore } from "@/data/alertsStore";

export function useAlerts(userId?: string) {
  const { alerts, readIds, isLoaded, fetchAlerts, markAsReadInternal } = useAlertsStore();

  useEffect(() => {
    if (!isLoaded) {
      fetchAlerts();
    }
  }, [isLoaded, fetchAlerts]);

  const filteredAlerts = useMemo(() => {
    return alerts.filter(a => !a.targetUserId || a.targetUserId === userId);
  }, [alerts, userId]);

  const unreadCount = filteredAlerts.filter(a => !readIds.includes(a.id)).length;

  return {
    alerts: filteredAlerts,
    unreadCount,
    readIds,
    markAsRead: markAsReadInternal
  };
}
